import { debounce } from './0_utils';

let mapInstance;
let activeFilterIndex = null;
let activeButton = null;
let activeInfoWindow = null;

document.addEventListener('DOMContentLoaded', function () {
    // Filter by location buttons
    document.querySelectorAll('.location-button').forEach((button) => {
        button.addEventListener('click', function () {
            const index = this.getAttribute('data-index');

            // Toggle filter: if clicking same button, show all markers
            if (activeFilterIndex === index) {
                showAllMarkers();
                activeFilterIndex = null;
                this.classList.remove('active');
                activeButton = null;
            } else {
                // Remove active class from previous button
                if (activeButton) {
                    activeButton.classList.remove('active');
                }

                // Add active class to current button
                this.classList.add('active');
                activeButton = this;

                filterMarkersByIndex(index);
                activeFilterIndex = index;
            }
        });
    });
});

function showAllMarkers() {
    if (!mapInstance || !mapInstance.markers) {
        return;
    }

    // Close active info window
    if (activeInfoWindow) {
        activeInfoWindow.close();
        activeInfoWindow = null;
    }

    mapInstance.markers.forEach((marker) => {
        marker.setVisible(true);
    });

    fitMapToMarkers(mapInstance.markers);
}

function filterMarkersByIndex(index) {
    console.log('Filtering markers by index:', index);
    if (!mapInstance || !mapInstance.markers) {
        return;
    }

    // Close active info window
    if (activeInfoWindow) {
        activeInfoWindow.close();
        activeInfoWindow = null;
    }

    let visibleMarkers = [];

    mapInstance.markers.forEach((marker) => {
        const isVisible = marker.index === index;
        marker.setVisible(isVisible);

        if (isVisible) {
            visibleMarkers.push(marker);
        }
    });

    fitMapToMarkers(visibleMarkers);
}

function renderMap(element) {
    let markers = element.querySelectorAll('.marker');

    // Map styles
    const styles = [];

    let mapOptions = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        styles: styles,
        disableDefaultUI: true,
    };

    mapInstance = new google.maps.Map(element, mapOptions);
    mapInstance.markers = [];

    // Add markers to the map
    markers.forEach(function (markerElement) {
        addMarker(markerElement, mapInstance);
    });

    centerMap(mapInstance);

    google.maps.event.addListenerOnce(mapInstance, 'idle', function () {
        const debouncedAdjustMapForMobile = debounce(function () {
            adjustMapForMobile(mapInstance);
        }, 200);
        window.addEventListener('resize', debouncedAdjustMapForMobile);
        adjustMapForMobile(mapInstance);

        preselectLocation();
    });
}

function adjustMapForMobile(mapInstance) {
    if (window.innerWidth < 640) {
        let map = document.querySelector('.acf-map');

        if (map) {
            let dataAttributes = map.dataset;
            let zoom = parseFloat(dataAttributes.zoomMap);
            let lat = parseFloat(dataAttributes.latMap);
            let lng = parseFloat(dataAttributes.lngMap);

            mapInstance.setCenter({ lat: lat, lng: lng });
            mapInstance.setZoom(zoom);
        }
    }
}

function fitMapToMarkers(markers, minZoom = 16) {
    if (markers.length === 0) return;

    const bounds = new google.maps.LatLngBounds();
    markers.forEach((marker) => bounds.extend(marker.getPosition()));

    mapInstance.fitBounds(bounds);
    const zoom = mapInstance.getZoom();
    mapInstance.setZoom(Math.min(zoom, minZoom));
}

function getMarkerIcon(markerElement) {
    const isMobile = window.innerWidth <= 640;
    const iconUrl = markerElement.getAttribute('data-marker-icon');

    // Check if icon URL exists
    if (!iconUrl) {
        return null;
    }

    return {
        url: iconUrl,
        scaledSize: new google.maps.Size(isMobile ? 18 : 24, isMobile ? 18 : 24),
        anchor: new google.maps.Point((isMobile ? 18 : 24) / 2, (isMobile ? 18 : 24) / 2),
    };
}

function createInfoWindowContent(markerElement) {
    // Get the inner HTML content from marker element
    const contentDiv = markerElement.querySelector('div');

    if (!contentDiv) {
        return '';
    }

    return contentDiv.innerHTML;
}

function addMarker(markerElement, map) {
    let latlng = new google.maps.LatLng(markerElement.getAttribute('data-lat'), markerElement.getAttribute('data-lng'));

    const markerIcon = getMarkerIcon(markerElement);

    let markerOptions = {
        position: latlng,
        map: map,
        index: markerElement.getAttribute('data-index'),
    };

    // Add icon only if it exists
    if (markerIcon) {
        markerOptions.icon = markerIcon;
    }

    let marker = new google.maps.Marker(markerOptions);

    // Create info window
    const infoWindowContent = createInfoWindowContent(markerElement);
    const infoWindow = new google.maps.InfoWindow({
        content: infoWindowContent,
    });

    // Add click listener to show info window
    marker.addListener('click', function () {
        // Close previous info window if exists
        if (activeInfoWindow) {
            activeInfoWindow.close();
        }

        infoWindow.open(map, marker);
        activeInfoWindow = infoWindow;
    });

    map.markers.push(marker);

    // Update icon on resize only if icon exists
    if (markerIcon) {
        window.addEventListener(
            'resize',
            debounce(() => {
                const updatedIcon = getMarkerIcon(markerElement);
                if (updatedIcon) {
                    marker.setIcon(updatedIcon);
                }
            }),
        );
    }
}

function centerMap(map) {
    let bounds = new google.maps.LatLngBounds();

    // Extend the bounds for each marker
    map.markers.forEach(function (marker) {
        let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng);
    });

    // If only one marker, center the map on it
    if (map.markers.length === 1) {
        map.setCenter(bounds.getCenter());
    } else {
        map.fitBounds(bounds);
    }
}

function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

function preselectLocation() {
    const locationParam = getQueryParam('location');

    if (!locationParam) return;

    const button = document.querySelector(`.location-button[data-index="${locationParam}"]`);

    if (!button) return;

    if (activeButton) {
        activeButton.classList.remove('active');
    }

    button.classList.add('active');
    activeButton = button;
    activeFilterIndex = locationParam;

    filterMarkersByIndex(locationParam);
}

// Render each map when the document is ready
document.querySelectorAll('.acf-map').forEach(function (mapElement) {
    renderMap(mapElement);
});
